<template>
	<dashboard-dropdown-section
		title="Applications Sent"
		type="locum-applications-sent"
		:items-shown="5"
		:items="requests"
		event-name="load-locum-applications-sent"
		@load-locum-applications-sent="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'LocumBookingRequests',

	components: { DashboardDropdownSection },

	data: () => ({
		requests: [],
	}),

	methods: {
		...mapActions('offers', ['FetchOffers']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const offersRequests = await this.FetchOffers({ startDate, endDate, offersType: 'locum-applications-sent' });
			this.requests = offersRequests.map(set => ({ ...set, event_start_date: set.request.booking_dates[0] }));
		},
	},
};
</script>
